import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

/**
 * Modification du payload d'un envoi AS400 en erreur (tracée dans l'historique).
 * Avec retry = true, l'envoi est relancé dans la foulée.
 * updateDatas renvoie true si l'opération a réussi.
 */
export default function useUpdateTourLogDatas() {
  const [isLoading, setIsLoading] = useState(false);

  const updateDatas = async (logId, datas, retry = false) => {
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/tours/tours-logs/${logId}/datas`, {
        datas,
        retry,
      });
      toast.success(response?.data?.message || 'Données corrigées.');
      return true;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'La correction des données a échoué. Veuillez réessayer.'
      );
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, updateDatas };
}
